var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#DEF1FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 22.5004C23.9467 22.5004 25.3341 21.9257 26.357 20.9028C27.3799 19.8799 27.9546 18.4925 27.9546 17.0459C27.9546 15.5992 27.3799 14.2118 26.357 13.1889C25.3341 12.166 23.9467 11.5913 22.5 11.5913C21.0534 11.5913 19.666 12.166 18.6431 13.1889C17.6202 14.2118 17.0455 15.5992 17.0455 17.0459C17.0455 18.4925 17.6202 19.8799 18.6431 20.9028C19.666 21.9257 21.0534 22.5004 22.5 22.5004ZM20.5526 24.5459C16.3552 24.5459 12.9546 27.9464 12.9546 32.1439C12.9546 32.8427 13.5214 33.4095 14.2202 33.4095H30.7799C31.4787 33.4095 32.0455 32.8427 32.0455 32.1439C32.0455 27.9464 28.6449 24.5459 24.4475 24.5459H20.5526Z",
    fill: "#1285C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d199a5e06a2ab0a1a350c85cccf57984.svg";
export { ForwardRef as ReactComponent };